import type { ClipboardEvent, KeyboardEvent, MutableRefObject } from "react";
import GstInput from "./GstInput";
import styles from "../../pages/GSTReconciliation/GSTReconciliation.module.scss";

interface GSTOtpStepProps {
  gstin: string;
  gstUsername: string;
  otp: string[];
  otpError: string;
  countdown: number;
  inputRefs: MutableRefObject<Array<HTMLInputElement | null>>;
  onOtpChange: (index: number, value: string) => void;
  onOtpKeyDown: (index: number, event: KeyboardEvent<HTMLInputElement>) => void;
  onOtpPaste: (event: ClipboardEvent<HTMLDivElement>) => void;
  onResend: (force?: boolean) => void;
}

export default function GSTOtpStep({
  gstin,
  gstUsername,
  otp,
  otpError,
  countdown,
  inputRefs,
  onOtpChange,
  onOtpKeyDown,
  onOtpPaste,
  onResend,
}: GSTOtpStepProps) {
  return (
    <>
      <div className={styles.connectFieldRow}>
        <div className={styles.connectFieldDisabled}>
          <GstInput label="GSTIN" value={gstin.toUpperCase()} disabled />
        </div>
        <div className={styles.connectFieldDisabled}>
          <GstInput label="Username" value={gstUsername} disabled />
        </div>
      </div>

      <div className={styles.otpSection}>
        <div className={styles.otpEnterGroup}>
          <span className={styles.otpFieldLabel}>Enter OTP</span>
          <div className={styles.otpRow} onPaste={onOtpPaste}>
            {otp.map((digit, index) => (
              <GstInput
                key={index}
                ref={(el) => {
                  inputRefs.current[index] = el;
                }}
                isOtpInput
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                hasError={!!otpError}
                onChange={(e) => onOtpChange(index, e.target.value)}
                onKeyDown={(e) => onOtpKeyDown(index, e)}
              />
            ))}
          </div>
        </div>

        {otpError ? (
          <p className={styles.otpInlineError}>
            Incorrect or expired OTP. Try again or{" "}
            <span className={styles.resendInlineLink} onClick={() => onResend(true)}>
              resend a new one
            </span>
            .
          </p>
        ) : (
          <div className={styles.otpResend}>
            Didn't receive the code?{" "}
            <span
              className={`${styles.resendLink} ${countdown > 0 ? styles.disabled : ""}`}
              onClick={() => onResend()}
            >
              {countdown > 0 ? `Resend in ${countdown}s` : "Resend"}
            </span>
          </div>
        )}
      </div>
    </>
  );
}
